module.exports = __webpack_public_path__ + "img/flag.b48a0c2f.svg";